import React from 'react';
import './AlertModal.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const AlertModal = ({ closeModal,
                        onClose,
                        onOk,
                        title,
                        message,
                        iconName = 'info',
                        okButtonName=null,
                        okButtonText='Ok',
                        closeOnBodyClick = false
                      }) => {
  return (
    <div
      className="confirmation-modal-content"
      onClick={ () => {
        if (closeOnBodyClick) {
          onOk();
          closeModal();
        }

        return false;
      } }
    >
      <div className="confirmation-modal-body">
        <div className="info-icon">
          <FontAwesomeIcon icon={ iconName } />
        </div>

        {title && (
            <div className="confirmation-modal-header" dangerouslySetInnerHTML={ {__html: title} } />
        )}

          {typeof message === 'string' && (
              <div className="confirmation-modal-text" dangerouslySetInnerHTML={ {__html: message} } />
        )}

        {typeof message !== 'string' && (
            <div className="confirmation-modal-text">
                {message}
            </div>
        )}

          <div className="confirmation-modal-buttons">
              <button
                  name={ okButtonName }
            className="btn btn-close-modal action-btn"
            onClick={
              () => {
                onOk();
                closeModal();
              }
            }
          >
            {okButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
